import { lazy, Suspense } from 'react';
import LoadingScreen from 'src/componentes/LoadingScreen';

const FusionChart = lazy(() => import('./chart-core'));

const ChartWrapper = (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <FusionChart {...props} />
  </Suspense>
);

export default ChartWrapper;
